// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2mETp","amount":"Amount_amount__1O1RP","tip":"Amount_tip__2C8Oa","tipHeader":"Amount_tipHeader__v2C7h","tipsWrap":"Amount_tipsWrap__17he6"};